
export const isPointInRect = (p, rect) => {
    return (
        p.x >=rect.x && p.x < rect.x + rect.width &&
        p.y >=rect.y && p.y < rect.y + rect.height
    );
};
